// Feature flags follow the G&L convention: FEATURE_FLAGS in /config.json is a
// comma separated list of the enabled flags, everything else is disabled.
// Flags for testing a change are named `feat-…-<ticket id>` / `fix-…-<ticket id>`
// and are removed once the change is stable.
export const FEATURE_FLAGS = Object.freeze({
  // same-origin session cookie for embedded content, see sessionCookie.js
  COOKIE_AUTHENTICATION: "feat-cookie-authentication-869fh0v3k",
});

export function parseFeatureFlags(value) {
  if (typeof value !== "string") return new Set();
  return new Set(
    value
      .split(",")
      .map((flag) => flag.trim())
      .filter(Boolean),
  );
}

export function isFeatureEnabled(config, flag) {
  return parseFeatureFlags(config?.FEATURE_FLAGS).has(flag);
}
